module.exports = __webpack_public_path__ + "static/media/visa_master_ae_union.ce16f5b9.png";